// import {createBrowserHistory} from 'history'
import {createHashHistory} from 'history'
import {configureStore} from '@reduxjs/toolkit'
import {routerMiddleware} from 'connected-react-router'
import rootReducer from './rootReducer'

// export const history = createBrowserHistory()
export const history = createHashHistory()

const store = configureStore({
    reducer: rootReducer(history),
    middleware : (getDefaultMiddleware) => getDefaultMiddleware().concat(routerMiddleware(history))
})

export default store;
